import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
	selector: "custom-form-text",
	template: `
		<div class="dynamic-field form-text" [formGroup]="group">
			<ic-form-field>
				<span icLabel><ng-content select="h3" /></span>

				<input
					icInput
					type="text"
					[formControlName]="config.name"
					[maxlength]="config.maxLength"
					[minlength]="config.minLength"
					[pattern]="config.pattern"
					[placeholder]="placeholder | language"
				/>

				@if (config.suffix && config.suffix.type === "icon") {
					<span class="suffix suffix-icon" icSuffix [ngClass]="config.suffix.value"> </span>
				}

				@if (config.suffix && config.suffix.type === "text") {
					<span class="suffix suffix-text" icSuffix>
						{{ config.suffix.value | language }}
					</span>
				}

				@if (hasError("required")) {
					<ic-error class="error">
						{{ "general.errors.required_field" | translate }}
					</ic-error>
				}
				@if (hasError("minlength") || hasError("maxlength")) {
					<ic-error class="error">
						{{ "general.errors.min_max_length" | translate: { min: config.minLength, max: config.maxLength } }}
					</ic-error>
				}
			</ic-form-field>
		</div>
	`,
	standalone: false,
})
export class FormTextComponent {
	@Input() config: any;
	// @ts-expect-error TS2564
	@Input() group: UntypedFormGroup;

	hasError(error: string): boolean {
		const control = this.group.get(this.config.name);
		// @ts-expect-error TS18047
		return control.touched && !!control.errors?.[error];
	}

	get placeholder() {
		return this.config.placeholder || "";
	}
}
